import * as React from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import { Login } from './User/Login';
import { Dashboard } from './dashboard/Dashboard';
import { GraphqlClient } from 'requestapijs';
import { API_URL } from '../config';
import { cssRaw } from 'typestyle';
import { UserContext } from './Common/UserContext';
import { ErrorBoundary } from './Common/ErrorBoundary';

// Same reasoning as HEADER in config.ts: GraphqlClient is a singleton built at
// module load, and GraphqlQuery destructures `headers` from it per request, so
// a getter re-reads the token each time instead of freezing the pre-login null.
new GraphqlClient({
  url: API_URL,
  headers: {
    get Authorization() {
      return localStorage.getItem('token');
    },
  },
});

cssRaw(`
  body {
    overflow-x: hidden;
  }

  *::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
  }

  *::-webkit-scrollbar
  {
    width: 6px;
    background-color: #F5F5F5;
  }

  *::-webkit-scrollbar-thumb
  {
    background-color: #000000;
  }

`);
export default class App extends React.Component<Props, State> {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <BrowserRouter>
      <ErrorBoundary>
      <Switch>
        <Route exact path='/' component={Login} />
        <UserContext>
          <Route path='/dashboard/' component={Dashboard} />
        </UserContext>
      </Switch>
      </ErrorBoundary>
    </BrowserRouter>
    );
  }
}

interface State {
}

interface Props {

}
